import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import "../styles/WhatsAppButton.css";

const WhatsAppButton = () => {
    const phoneNumber = "5532991100949"; // formato internacional, sem "+"
    const message = "Olá! Gostaria de saber mais sobre os produtos da ROS Dormentes.";

    const handleClick = () => {
        const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(url, "_blank");
    };

    return (
        <div className="whatsapp-float-wrapper" onClick={handleClick}>
            <button className="whatsapp-float" aria-label="Fale conosco no WhatsApp">
                <FaWhatsapp className="whatsapp-icon" />
                <span className="whatsapp-cta">Fale conosco</span>
            </button>
        </div>
    );
};

export default WhatsAppButton;
